// =============================
// src/components/material/view/MaterialPOView.jsx
// =============================
import { useNavigate, useParams } from "react-router-dom";
import TableCell from "../../components/common/ui/TableCell";

export default function MaterialPOView({ data }) {
  const navigate = useNavigate();
  const { id: projectId } = useParams();

  // -----------------------------
  // 데이터 정규화
  // -----------------------------
  const dns = data?.dns || data?.doc_dns || "-";
  const header = data?.header || {};
  const lines = Array.isArray(data?.lines) ? data.lines : [];

  const total = lines.reduce((sum, r) => sum + Number(r.amount || 0), 0);

  // -----------------------------
  // 포맷 유틸
  // -----------------------------
  const fmtDate = (v) => {
    if (!v) return "-";
    const d = new Date(v);
    return isNaN(d.getTime()) ? String(v) : d.toLocaleDateString();
  };

  const fmtNum = (v) => {
    if (v === undefined || v === null || v === "") return "-";
    const n = Number(v);
    return isNaN(n) ? String(v) : n.toLocaleString();
  };

  // -----------------------------
  // GR 생성 이동
  // -----------------------------
  const goCreateGR = () => {
    navigate(`/project/${projectId}/material/gr/new`, {
      state: {
        poHeader: header,
        poItems: lines,
        from: dns,
      },
    });
  };

  // -----------------------------
  // RENDER
  // -----------------------------
  return (
    <div className="space-y-6">
      {/* 상단 액션 */}
      <div className="flex justify-end">
        <button className="btn-basic-sm" onClick={goCreateGR}>
          입고서 작성 (GR)
        </button>
      </div>

      {/* 기본 정보 */}
      <table className="w-full border text-sm">
        <tbody>
          <tr>
            <TableCell label="문서 번호" colSpan={3} value={dns} />
          </tr>
          <tr>
            <TableCell label="발주일" value={fmtDate(header.po_date)} />
            <TableCell label="공급업체" value={header.supplier || "-"} />
          </tr>
          <tr>
            <TableCell
              label="납기 요청일"
              value={fmtDate(header.request_date)}
            />
            <TableCell label="납품 장소" value={header.delivery_place || "-"} />
          </tr>
          <tr>
            <TableCell
              label="비고 / 메모"
              colSpan={3}
              value={header.remark || "-"}
            />
          </tr>
        </tbody>
      </table>

      {/* 품목 테이블 */}
      <table className="w-full border-collapse border text-sm">
        <thead className="bg-gray-100">
          <tr>
            <th className="border px-2">코드</th>
            <th className="border px-2">품명</th>
            <th className="border px-2">규격</th>
            <th className="border px-2">단위</th>
            <th className="border px-2 text-right">수량</th>
            <th className="border px-2 text-right">단가</th>
            <th className="border px-2 text-right">금액</th>
            <th className="border px-2">비고</th>
          </tr>
        </thead>

        <tbody>
          {lines.length === 0 ? (
            <tr>
              <td colSpan={8} className="py-4 text-center text-gray-400">
                발주 품목이 없습니다.
              </td>
            </tr>
          ) : (
            lines.map((r, i) => (
              <tr key={i}>
                <td className="border px-2">{r.code}</td>
                <td className="border px-2">{r.name}</td>
                <td className="border px-2">{r.spec}</td>
                <td className="border px-2 text-center">{r.unit}</td>
                <td className="border px-2 text-right">{fmtNum(r.qty)}</td>
                <td className="border px-2 text-right">
                  {fmtNum(r.unit_price)}
                </td>
                <td className="border px-2 text-right">{fmtNum(r.amount)}</td>
                <td className="border px-2">{r.remark || "-"}</td>
              </tr>
            ))
          )}
        </tbody>

        <tfoot className="bg-gray-50">
          <tr>
            <td colSpan={6} className="border px-2 text-right font-semibold">
              합계
            </td>
            <td className="border px-2 text-right font-semibold">
              {fmtNum(total)}
            </td>
            <td className="border px-2"></td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
}
